export default "__VITE_ASSET__CQIrz5Wh__"